import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
    label: ReactNode;
    className?: string;
    children: ReactNode;
    labelClassName?: string;
}

export function HorizontalReadOnlyField({ label, className, children, labelClassName }: Props) {
    return (
        <div className={twMerge('flex gap-1', className)}>
            <div className={twMerge('break-words font-medium', labelClassName)}>{label}</div>
            <div className="break-words">{children}</div>
        </div>
    );
}
